import React from "react";
import { cn } from "../../lib/utils";

const DateCell = ({ value, locale = "ar-AE", options, className = "" }) => {
  const date = value ? new Date(value) : null;
  const valid = date && !Number.isNaN(date.getTime());
  return (
    <time
      className={cn(
        "font-mono text-sm tabular-nums text-neutral-700 dark:text-neutral-200",
        className,
      )}
      dateTime={valid ? date.toISOString() : undefined}
    >
      {valid
        ? date.toLocaleDateString(
            locale,
            options || { year: "numeric", month: "short", day: "numeric" },
          )
        : "—"}
    </time>
  );
};

export default DateCell;
